// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__28uLA","title":"Images45_title__19aZX","images":"Images45_images__1WJt_"};